if (typeof Main !== " function") {
  let Main = function () {
    let duracion = 400;

    let breakpoint = 576;
    let formato = "horizontal";

    function fetchData() {
      let estados = Window.data.json.municipios;
      let municipios = Window.data.json.municipios;
      let data = Window.data.csv.data;
      let piramide = Window.data.csv.piramide;

      let params = {};
      params.estados = estados;
      params.municipios = municipios;
      params.data = data;
      params.piramide = piramide;
      procesaData(params);
    }

    function procesaData(params) {
      generaGraficas(params);
    }

    function generaGraficas(params) {
      let elEpidemia = d3.select("#epidemia") || false;
      if (!elEpidemia.empty()) {
        let epidemia = new Epidemia(elEpidemia, duracion, formato);
        delete window.Epidemia;
      }

      let elZoom = d3.select("#zoom") || false;
      if (!elZoom.empty()) {
        let zoom = new Zoom(elZoom, duracion, formato, {
          estados: params.estados,
          municipios: params.municipios,
        });
        delete window.Zoom;
      }

      let elMapaCirculos = d3.select("#mapa_circulos") || false;
      if (!elMapaCirculos.empty()) {
        let mapaCirculos = new MapaCirculos(
          elMapaCirculos,
          duracion,
          params.municipios,
        );
        delete window.MapaCirculos;
      }

      let elLineas = d3.select("#lineas") || false;
      if (!elLineas.empty()) {
        let lineas = new Lineas(elLineas, duracion, formato, params.data);
        delete window.Lineas;
      }

      let elPiramide = d3.select("#piramide") || false;
      if (!elPiramide.empty()) {
        let piramide = new Piramide(
          elPiramide,
          duracion,
          formato,
          params.piramide,
        );
        delete window.Piramide;
      }
    }

    function setup() {
      //https://unpkg.com/d3-time-format@2.3.0/locale/es-MX.json
      d3.timeFormatDefaultLocale({
        dateTime: "%x, %X",
        date: "%d/%m/%Y",
        time: "%-I:%M:%S %p",
        periods: ["AM", "PM"],
        days: [
          "domingo",
          "lunes",
          "martes",
          "miércoles",
          "jueves",
          "viernes",
          "sábado",
        ],
        shortDays: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        months: [
          "enero",
          "febrero",
          "marzo",
          "abril",
          "mayo",
          "junio",
          "julio",
          "agosto",
          "septiembre",
          "octubre",
          "noviembre",
          "diciembre",
        ],
        shortMonths: [
          "ene",
          "feb",
          "mar",
          "abr",
          "may",
          "jun",
          "jul",
          "ago",
          "sep",
          "oct",
          "nov",
          "dic",
        ],
      });
      setFormato();
      fetchData();
    }

    function setFormato() {
      let w = document.documentElement.clientWidth;
      formato = w > breakpoint ? "horizontal" : "vertical";
    }

    setup();
  };

  windowReady.ready(function () {
    let charts = new Main();
  });
}
